export default __webpack_public_path__ + "static/media/TRIB-1.908b1024.jpg";